import { render, staticRenderFns } from "./PaymentMethodIcon.vue?vue&type=template&id=790ca18b&scoped=true"
import script from "./PaymentMethodIcon.vue?vue&type=script&lang=js"
export * from "./PaymentMethodIcon.vue?vue&type=script&lang=js"
import style0 from "./PaymentMethodIcon.vue?vue&type=style&index=0&id=790ca18b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "790ca18b",
  null
  
)

export default component.exports